import { Component, Input } from '@angular/core';
import { CoalitionListColumnDef } from './coalition-list.model';
import { ListCoalitionResultDto } from "@shared/clients/api.generated";

@Component({
  selector: 'valg-dk-coalition-list',
  templateUrl: './coalition-list.component.html',
})
export class CoalitionListComponent {
  coalitionListColumnDef = CoalitionListColumnDef;
  @Input() data: ListCoalitionResultDto[] = [];
}
